<template>
  <div class="page">
    <header class="nav">
      <h1>James Mundia</h1>
      <span class="pill">Builder · Tech Leadership · Product</span>
    </header>

    <section class="hero">
      <h2>Hello, I’m James.</h2>
      <p>
        I lead teams and products from zero-to-one through growth. I enjoy
        shipping thoughtful experiences, aligning engineering with business outcomes,
        and keeping a bias for action without losing quality.
      </p>
      <div class="cta-row">
        <a class="btn primary" href="mailto:james@jamesmundia.com">Get in touch</a>
        <a class="btn" href="https://www.linkedin.com/in/jmundia" target="_blank" rel="noreferrer">
          LinkedIn
        </a>
        <a class="btn" href="https://github.com/jmundia" target="_blank" rel="noreferrer">
          GitHub
        </a>
      </div>

      <div class="grid">
        <div class="card">
          <h3>What I’m focused on</h3>
          <p>Product strategy, technical leadership, and guiding teams through ambiguous problems.</p>
        </div>
        <div class="card">
          <h3>Recent work</h3>
          <p>Building scalable backends, launching customer-facing apps, and mentoring engineers.</p>
        </div>
        <div class="card">
          <h3>How I work</h3>
          <p>Clear communication, lightweight process, strong ownership, and measurable results.</p>
        </div>
        <div class="card image-card">
          <img
            src="/james-golf.JPG"
            alt="James on the course"
          />
        </div>
      </div>
    </section>

    <p class="footer">Based in PNW · Available for select collaborations</p>
  </div>
</template>

<script setup>
</script>

<style scoped>
</style>
